<template>
  <v-row class="footer">
    <div class="footer-img">
      <img src="@/assets/footer-img.svg" />
    </div>
    <div class="curve">
      <img src="@/assets/curve.svg" />
    </div>
    <v-row>
      <v-col cols="12" sm="3" md="3" lg="3" class="text-left">
        <span class="dentaholic">DENTOHOLIC</span>
      </v-col>
      <v-col cols="12" sm="9" md="9" lg="9">
        <v-row class="font-16">
          <v-col cols="12">
            <p class="sub-header">
              Dentoholic helps surgeries discover and securely purchase <br />
              a wide range of dental equipment and supplies for their practices
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="footer-list">
      <v-spacer> </v-spacer>
      <v-col cols="12" sm="9" md="9" lg="9">
        <v-row>
        <v-col cols="12" sm="5">
            <v-btn text small>About Us</v-btn>
            <v-btn text small>Terms & Conditions</v-btn>
            <v-btn text small>Privacy Policy</v-btn>
         
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn @click="navigateToSurgerySignUp" text small>Surgery Signup</v-btn>
            <v-btn @click="navigateToSupplierSignUp" text small>Supplier Signup</v-btn>
            <v-btn text small>Contact Us</v-btn>
            <!-- <v-btn text small>Buyers Guides</v-btn>
            <v-btn text small>News</v-btn>
            <v-btn text small>Events</v-btn>
            <v-btn text small>Promotions</v-btn>
            <v-btn text small>Newsletter Signup</v-btn>
            <v-btn text small>Newsletter Archives</v-btn> -->
          </v-col>
          <v-col cols="12" sm="4">
            <!-- <v-btn text small>Newsletter Archives</v-btn> -->
            <p>
              We accept all major credit and debit cards
            </p>
            <!-- <div class="input-inner-icon">
              <v-text-field solo rounded flat label="Your Email"></v-text-field>
              <v-btn text class="icon-wrapper">
                Send
              </v-btn>
            </div> -->
            <div class="payment-logos">
              <img src="@/assets/stripe.svg" />
              <img src="@/assets/visa.svg" />
              <img src="@/assets/paypal.svg" />
            </div>
          </v-col> 
        </v-row>
      </v-col>
    </v-row>
    <v-row class="copyright-wrapper">
      <v-spacer></v-spacer>
      <v-col cols="12" sm="9" md="9" lg="9" class="copyright">
        <div class="social-logos">
          <div class="media-wrapper">
            <v-icon>mdi-twitter</v-icon>
          </div>
          <div class="media-wrapper">
            <v-icon>mdi-linkedin</v-icon>
          </div>
          <div class="media-wrapper">
            <v-icon>mdi-facebook</v-icon>
          </div>
          <div class="media-wrapper">
            <v-icon>mdi-instagram</v-icon>
          </div>
        </div>
        <div class="copyright-content">
          <span>© 2022 DENTOHOLIC</span> <span class="mx-3"> | </span>
          <a href="#">TERMS OF SERVICE</a> <span class="mx-3"> | </span>
          <a href="#">PRIVACY POLICY</a> <span class="mx-3"> | </span>
          <!-- <a href="#">SITE MAP</a> -->
        </div>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
export default {
  name: "HomeFooter",
  methods: {
    navigateToSurgerySignUp() {
      alert('i')
      this.$router.push({name: 'Customer'})
    },
    navigateToSupplierSignUp() {
      this.$router.push({name: 'Supplier'})
    }
  }
};
</script>

<style scoped lang="scss" src="./HomeFooter.scss"></style>
